import { Button } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { buildUpgradePlanUrl, type PaywallTrackingProps } from '@vimeo/picox';

interface OtherPlansButtonProps {
  paywallTracking: PaywallTrackingProps;
}

export function OtherPlansButton({ paywallTracking }: OtherPlansButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.assign(buildUpgradePlanUrl(paywallTracking));
    }
  };

  return (
    <Button size="lg" variant="tertiary" width="100%" onClick={handleClick}>
      {translate('Other Plans')}
    </Button>
  );
}
